import { IAuthToken } from '../utils/constants/interfaces';
import {
  IAppSettings,
  IStoreState,
  IUserState,
  Actions,
  ActionType,
  ISetApiReady,
  ISetApplicationReady,
  ISetUser,
  ISetUserAuthToken,
  ISetUserLastApiActivity,
  ISetUserLoggedOut,
  ISetIsLoading,
  ISetDevSetupRequired,
  ISetApplicationVersion
} from './store.actions';

export const setUser = (payload: IUserState): ISetUser => ({
  type: ActionType.SetUser,
  payload: payload
});

export const setUserAuthToken = (payload: IAuthToken): ISetUserAuthToken => ({
  type: ActionType.SetUserAuthToken,
  payload: payload
});

export const setUserLoggedOut = (): ISetUserLoggedOut => ({
  type: ActionType.SetUserLoggedOut
});

export const setUserLastActivity = (payload: Date): ISetUserLastApiActivity => ({
  type: ActionType.SetUserLastApiActivity,
  payload: payload
});

export const setIsLoading = (payload: boolean): ISetIsLoading => ({
  type: ActionType.SetIsLoading,
  payload: payload
});

export const setDevSetupRequired = (payload: boolean): ISetDevSetupRequired => ({
  type: ActionType.SetDevSetupRequired,
  payload: payload
});

export const setApplicationVersion = (payload: string): ISetApplicationVersion => ({
  type: ActionType.SetApplicationVersion,
  payload: payload
});

export const setApplicationReady = (payload: boolean): ISetApplicationReady => ({
  type: ActionType.SetApplicationReady,
  payload: payload
});

export const setApiReady = (payload: boolean): ISetApiReady => ({
  type: ActionType.SetApiReady,
  payload: payload
});

/* reducer */
export const mainReducer = (state: IStoreState, action: Actions) => {
  const { user, settings } = state;

  switch (action.type) {
    case ActionType.SetUserAuthToken:
      return {
        ...state,
        user: {
          ...user,
          userId: action.payload.userId,
          userName: action.payload.userName,
          permissions: action.payload.permissions,
          customersLoaded: false,
          token: action.payload.token,
          expiresAt: action.payload.expiresAt,
          refreshAt: action.payload.refreshAt
        } as IUserState
      };
    case ActionType.SetUserLoggedOut:
      return {
        ...state,
        user: {
          ...user,
          userId: null,
          userName: '',
          permissions: [],
          customersLoaded: false,
          customers: [],
          token: null,
          expiresAt: null,
          refreshAt: null
        } as IUserState
      };
    case ActionType.SetUserLastApiActivity:
      return {
        ...state,
        user: {
          ...user,
          lastApiActivity: action.payload
        } as IUserState
      };
    case ActionType.SetIsLoading:
      return {
        ...state,
        settings: {
          ...settings,
          isLoading: action.payload
        } as IAppSettings
      };
    case ActionType.SetDevSetupRequired:
      return {
        ...state,
        settings: {
          ...settings,
          devSetupRequired: action.payload
        } as IAppSettings
      };
    case ActionType.SetApplicationVersion:
      return {
        ...state,
        settings: {
          ...settings,
          applicationVersion: action.payload
        } as IAppSettings
      };
    case ActionType.SetApplicationReady:
      return {
        ...state,
        settings: {
          ...settings,
          applicationReady: action.payload
        } as IAppSettings
      };
    case ActionType.SetApiReady:
      return {
        ...state,
        settings: {
          ...settings,
          apiReady: action.payload
        } as IAppSettings
      };
    case ActionType.SetUser:
      return {
        ...state,
        user: action.payload
      };

    default:
      return state;
  }
};
